import {useEffect, useState} from "react";

import {IVendorOfferWithoutVendorConfiguration} from "../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../api/get_vendor_detail_offers";
import {resetInactiveOffersPage, resetSoldOffersPage, setInactiveOffersNextPage, setSoldOffersNextPage} from "../state/vendor_offer_list_slice";
import {buildVendorDetailInactiveOffersParams, buildVendorDetailSoldOffersParams} from "../utils/vendor_detail_offers_query_params";

interface IParams {
    vendorId: number;
    region: number | null;
}

interface IOfferListState {
    offers: IVendorOfferWithoutVendorConfiguration[];
    isFetching: boolean;
    count: number;
    page: number;
    loadMore: () => void;
    reset: () => void;
}

interface IResult {
    sold: IOfferListState;
    inactive: IOfferListState;
}

export function useVendorUnavailableOfferLists({vendorId, region}: IParams): IResult {
    const dispatch = useAppDispatch();

    const soldPage = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const inactivePage = useAppSelector((state) => state.vendorDetailViewSlice.inactiveOffersListParams.page);

    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const [visibleInactiveOffers, setVisibleInactiveOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);

    const {data: soldData, isFetching: isSoldFetching} = useGetVendorDetailOffersQuery(buildVendorDetailSoldOffersParams({vendorId, region, page: soldPage}));
    const {data: inactiveData, isFetching: isInactiveFetching} = useGetVendorDetailOffersQuery(
        buildVendorDetailInactiveOffersParams({vendorId, region, page: inactivePage})
    );

    useEffect(() => {
        if (soldData?.results) {
            if (soldPage > 1) {
                setVisibleSoldOffers((prev) => [...prev, ...soldData.results]);
            } else {
                setVisibleSoldOffers(soldData.results);
            }
        }
    }, [soldData]);

    useEffect(() => {
        if (inactiveData?.results) {
            if (inactivePage > 1) {
                setVisibleInactiveOffers((prev) => [...prev, ...inactiveData.results]);
            } else {
                setVisibleInactiveOffers(inactiveData.results);
            }
        }
    }, [inactiveData]);

    return {
        sold: {
            //returning results for first page so ssr could see offers if they exist
            offers: soldPage === 1 ? (soldData?.results ?? []) : visibleSoldOffers,
            isFetching: isSoldFetching,
            count: soldData?.count ?? 0,
            page: soldPage,
            loadMore: () => dispatch(setSoldOffersNextPage()),
            reset: () => dispatch(resetSoldOffersPage())
        },
        inactive: {
            //returning results for first page so ssr could see offers if they exist
            offers: inactivePage === 1 ? (inactiveData?.results ?? []) : visibleInactiveOffers,
            isFetching: isInactiveFetching,
            count: inactiveData?.count ?? 0,
            page: inactivePage,
            loadMore: () => dispatch(setInactiveOffersNextPage()),
            reset: () => dispatch(resetInactiveOffersPage())
        }
    };
}
import {useEffect, useState} from "react";

import {IVendorOfferWithoutVendorConfiguration} from "../../offer/types/VendorOffersListResponse";
import {useAppDispatch, useAppSelector} from "../../store/hooks";
import {useGetVendorDetailOffersQuery} from "../api/get_vendor_detail_offers";
import {resetInactiveOffersPage, resetSoldOffersPage, setInactiveOffersNextPage, setSoldOffersNextPage} from "../state/vendor_offer_list_slice";
import {buildVendorDetailInactiveOffersParams, buildVendorDetailSoldOffersParams} from "../utils/vendor_detail_offers_query_params";

interface IParams {
    vendorId: number;
    region: number | null;
}

interface IOfferListState {
    offers: IVendorOfferWithoutVendorConfiguration[];
    isFetching: boolean;
    count: number;
    page: number;
    loadMore: () => void;
    reset: () => void;
}

interface IResult {
    sold: IOfferListState;
    inactive: IOfferListState;
}

export function useVendorUnavailableOfferLists({vendorId, region}: IParams): IResult {
    const dispatch = useAppDispatch();

    const soldPage = useAppSelector((state) => state.vendorDetailViewSlice.soldOffersListParams.page);
    const inactivePage = useAppSelector((state) => state.vendorDetailViewSlice.inactiveOffersListParams.page);

    const [visibleSoldOffers, setVisibleSoldOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);
    const [visibleInactiveOffers, setVisibleInactiveOffers] = useState<IVendorOfferWithoutVendorConfiguration[]>([]);

    const {data: soldData, isFetching: isSoldFetching} = useGetVendorDetailOffersQuery(buildVendorDetailSoldOffersParams({vendorId, region, page: soldPage}));
    const {data: inactiveData, isFetching: isInactiveFetching} = useGetVendorDetailOffersQuery(
        buildVendorDetailInactiveOffersParams({vendorId, region, page: inactivePage})
    );

    useEffect(() => {
        if (soldData?.results) {
            if (soldPage > 1) {
                setVisibleSoldOffers((prev) => [...prev, ...soldData.results]);
            } else {
                setVisibleSoldOffers(soldData.results);
            }
        }
    }, [soldData]);

    useEffect(() => {
        if (inactiveData?.results) {
            if (inactivePage > 1) {
                setVisibleInactiveOffers((prev) => [...prev, ...inactiveData.results]);
            } else {
                setVisibleInactiveOffers(inactiveData.results);
            }
        }
    }, [inactiveData]);

    return {
        sold: {
            //returning results for first page so ssr could see offers if they exist
            offers: soldPage === 1 ? (soldData?.results ?? []) : visibleSoldOffers,
            isFetching: isSoldFetching,
            count: soldData?.count ?? 0,
            page: soldPage,
            loadMore: () => dispatch(setSoldOffersNextPage()),
            reset: () => dispatch(resetSoldOffersPage())
        },
        inactive: {
            //returning results for first page so ssr could see offers if they exist
            offers: inactivePage === 1 ? (inactiveData?.results ?? []) : visibleInactiveOffers,
            isFetching: isInactiveFetching,
            count: inactiveData?.count ?? 0,
            page: inactivePage,
            loadMore: () => dispatch(setInactiveOffersNextPage()),
            reset: () => dispatch(resetInactiveOffersPage())
        }
    };
}
